/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { useState, useContext, useEffect, useRef } from 'react';
import {
	Row,
	Col,
	Card,
	Form,
	Input,
	DatePicker,
	Select,
	Button,
	message,
	Modal,
	Spin,
	Radio,
} from 'antd';
import { useHistory } from 'react-router-dom';
import {
	PrinterOutlined,
	SyncOutlined,
	SnippetsOutlined,
	RollbackOutlined,
	SaveOutlined,
	DeleteOutlined,
} from '@ant-design/icons';

import PageTitle from 'shared_components/page_title';
import PaymentsDataTable from './payments_dataTable.jsx';
import './payments_data_entry.css';
import { AlphaNumInput } from 'shared_components/pattern_input';
import { AutoComplete } from 'antd';

import {
	fetchPaymentMethod,
	fetchBank,
	fetchVatInput,
	addPaymentHeader,
	fetchCustomersName,
	updatePaymentHeader,
	fetchHeaderDetails,
	deletePaymentLines,
	fetchExistingOr,
	fetchBalanceDetailsAPI,
	fetchBalanceDetailsNewStatusAPI,
	fetchCustomerDetailsAPI,
	generatePaymentsReport,
	tmpDeleteDetail,
} from 'services/payments/payments';

import {
	fetchMessageListAPI,
	fetchStatusListAPI,
	fetchBillAddListAPI,
	fetchInvTypesListAPI,
	fetchAgentsListAPI,
} from 'services/shared/fetchLovList';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import Message from 'shared_components/message';
import moment from 'moment';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { numberFormat, formatTIN } from 'utils/helper';
import { toUpper, sumBy } from 'lodash';

import { UserAccessContext } from 'context/userAccess';
// import { isValueObject } from 'immutable';

const { Option } = Select;

const footerStyleRight = {
	textAlign: 'right',
};

const buttonStyle = {
	// background: '#0487C8',
	// border: '#0487C8',
};

const formItemStyle = { paddingBlock: 0, marginBlock: 4, borderBlock: 0 };
const INVOICE_PLACEHOLDER_VALUE = 'SELECT_INVOICE';

const getInvoiceNoValue = paymentLine => {
	if (!paymentLine || paymentLine.invoice_no === undefined || paymentLine.invoice_no === null) {
		return '';
	}

	return paymentLine.invoice_no.toString().trim();
};

const isValidPaymentLine = paymentLine => {
	const invoiceNo = getInvoiceNoValue(paymentLine);
	return invoiceNo !== '' && invoiceNo !== INVOICE_PLACEHOLDER_VALUE;
};

export default function PaymentsDataEntry(props) {
	const [isloading, setLoading] = useState(true);
	const [printLoading, setPrintLoading] = useState(false);
	const { userAccess } = useContext(UserAccessContext);
	const invoiceDetailsProps = props.invoiceDetails === undefined ? '' : props.invoiceDetails;
	const isEditting = props.isEditting !== undefined ? props.isEditting : false; //forced to avoid catching 'undefined' values in dependent components
	const navigate = useHistory();
	const [status, setStatus] = useState();
	const [submitAction, setSubmitAction] = useState(null);
	const submitActionRef = useRef(null);
	const [disable, setDisable] = useState(true);
	const [disableBank, setDisableBank] = useState(true);
	const [disableCheck, setDisableCheck] = useState(true);
	const [form] = Form.useForm();
	const [paymentList, setPaymentList] = useState([]);
	const [bankList, setBankList] = useState([]);
	const [vatList, setvatList] = useState([]);
	const [customerNameList, setCustomerNameList] = useState([]);
	const [filteredCustomerOptions, setFilteredCustomerOptions] = useState([]);
	const [paymentDetail, setPaymentDetail] = useState([]);
	const [messagesList, setMessagesList] = useState([]);
	const [dataForRefresh, setDataForRefresh] = useState([]);
	const [lovstatus, setLovStatus] = useState([]);
	const [billAddressList, setBillAddressList] = useState([]);
	const [linesForDelete, setLinesForDelete] = useState([]);
	const [paymentTotAmt, setpaymentTotAmt] = useState(0);
	const [totalVatSales, setTotalVatSales] = useState(0);
	const [customerID, setCustomerID] = useState();
	const [selectedCustomerID, setSelectedCustomerID] = useState(''); // Clean customer ID for payload
	const [selectedCustomerName, setSelectedCustomerName] = useState(''); // Customer name for display
	const [listInvBalances, setListInvBalances] = useState([]);
	const [clearPaymentLines, setClearPaymentLines] = useState(false);
	const [invTypesList, setInvTypesList] = useState([]);
	const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
	const cancelPayment = userAccess['payments'].cancel;
	const updatePayment = userAccess['payments'].update;
	const [ewtValue, setEwtValue] = useState();
	const [paymentTotVatSales, setPaymentTotVatSales] = useState(0);
	const [paymentTotVatAmt, setPaymentTotVatAmt] = useState(0);
	const [agentsList, setAgentsList] = useState([]);
	const hideEWTColumns = true;

	const fetchBalanceDetailsByScenario = async (customerId, currentStatus, currentPaymentId) => {
		if (!customerId) return [];

		if (props.isEditting && currentStatus === 'NEW') {
			return fetchBalanceDetailsNewStatusAPI(customerId, currentPaymentId);
		}

		return fetchBalanceDetailsAPI(customerId);
	};

	useEffect(() => {
		async function fetchData() {
			const paymentList = await fetchPaymentMethod();
			// set bank and cheque to disable/enable
			if (props.isEditting && invoiceDetailsProps.payment_method_id) {
				const payMethod = paymentList.filter(
					items => items.payment_method_id === invoiceDetailsProps.payment_method_id,
				);
				const is_bank = payMethod[0] ? (payMethod[0].is_bank === false ? true : false) : false;
				const is_cheque = payMethod[0] ? (payMethod[0].is_cheque === false ? true : false) : false;

				setDisableBank(is_bank);
				setDisableCheck(is_cheque);
			}

			const agents = await fetchAgentsListAPI();
			const bankList = await fetchBank();
			const vatList = await fetchVatInput();
			const customerNames = await fetchCustomersName();
			const loadstatus = await fetchStatusListAPI('PAYMENTS');
			const invTypes = await fetchInvTypesListAPI();
			const messages = await fetchMessageListAPI();

			setAgentsList(agents);
			setPaymentList(paymentList);
			setBankList(bankList);
			setvatList(vatList);
			setCustomerNameList(customerNames);
			setLovStatus(loadstatus);
			setInvTypesList(invTypes);
			setMessagesList(messages);

			// console.log('userAccess =>', userAccess);
			// console.log('stat =>', status);
			// console.log('updatePayment =>', updatePayment);

			//test loader spin
			if (messages) {
				setLoading(false);
			}
		}
		fetchData();
	}, []);

	useEffect(() => {
		if (props.isEditting) {
			async function fetchData() {
				// const { or_no } = form.getFieldValue(); -- commented by pabs or_no is existing from props
				const or_no = invoiceDetailsProps.or_no;

				// update payment details temporary value to delete
				await tmpDeleteDetail(0);

				const result = await fetchHeaderDetails(or_no);
				const { status_name, customer_id, vatable_sales, total_payment_amount, total_amount_due } = result && result[0] ? result[0] : {};

				const activePaymentID = (result && result[0] && result[0].payment_id) || invoiceDetailsProps.payment_id;
				const balanceDetails = customer_id
					? await fetchBalanceDetailsByScenario(customer_id, status_name, activePaymentID)
					: [];
				setTotalVatSales(vatable_sales || 0);
				setpaymentTotAmt(parseFloat(total_amount_due || 0));
				setStatus(status_name || '');
				setCustomerID(customer_id || '');
				setListInvBalances(balanceDetails);

				// Explicitly set form fields for totals to ensure they match the fetched data
				form.setFieldsValue({
					total_payment_amount: numberFormat(total_amount_due || 0, 2),
					total_amount_due: numberFormat(total_payment_amount || 0, 2),
					house_own: toUpper((result && result[0] && result[0].house_own) || invoiceDetailsProps.house_own || ''),
				});

				// Initialize clean customer states for editing mode
				if (customer_id && invoiceDetailsProps.customer_id) {

					// Find customer name from customerNameList if not provided in invoiceDetailsProps
					let customerName = invoiceDetailsProps.customer;
					if (!customerName && customerNameList.length > 0) {
						const foundCustomer = customerNameList.find(customer => customer.customer_id === invoiceDetailsProps.customer_id);
						customerName = foundCustomer ? foundCustomer.customer : '';
					}

					setSelectedCustomerID(invoiceDetailsProps.customer_id);
					setSelectedCustomerName(customerName);

					// Set form field to display customer name, not ID
					form.setFieldsValue({
						customer_id: customerName
					});
				}
				
				setDisable(false);

				// form.setFieldsValue({ vatableSales: numberFormat(vatable_sales) });

				//test loader spin
				if (balanceDetails) {
					setLoading(false);
				}
			}
			fetchData();
		}
	}, []);

	useEffect(() => {
		checkVatInput();
	}, []);

	//figures default value for Status
	if (isEditting) {
		form.setFieldsValue({
			status: status,
		});
	} else {
		form.setFieldsValue({
			status: 'NEW',
		});
	}

	// New dedicated function for customer selection
	const handleCustomerSelection = async (customerId, customerName) => {
		console.log('Customer selected - ID:', customerId, 'Name:', customerName);
		
		// Set clean states
		setSelectedCustomerID(customerId);
		setSelectedCustomerName(customerName);
		
		// Call existing logic
		onChangeCustomer(customerId);
	};

	const onChangeCustomer = async e => {
		const m0026 = messagesList.filter(items => items.message_code === 'M0026');
		let balanceDetails = [];
		setDisable(false);

		if (e !== undefined) {
			// catches clearing from select element
			balanceDetails = await fetchBalanceDetailsByScenario(
				e,
				status || invoiceDetailsProps.status_name || 'NEW',
				invoiceDetailsProps.payment_id,
			);
			setListInvBalances(balanceDetails);
			execCustChanges(e);
		}

		if (customerID === undefined) {
			//to handle new payments
			setCustomerID(e);
		}

		if (paymentDetail.length > 0) {
			Modal.confirm({
				title: m0026[0].message_title,
				icon: <ExclamationCircleOutlined />,
				content: m0026[0].message_display,
				okText: 'YES',
				cancelText: 'NO',
				onOk: () => {
					setCustomerID(e);
					toggleClearing();
					execCustChanges(e);
				},
				onCancel: () => {
					form.setFieldsValue({
						customer_id: customerID,
					});
					execCustChanges(customerID);
				},
			});
		}

		async function execCustChanges(param) {
			try {
				const billAddDet = await fetchBillAddListAPI(param);
				const selectedCustomer = customerNameList.find(
					customer => Number(customer.customer_id) === Number(param),
				);
				let customerAgentId =
					selectedCustomer && selectedCustomer.agent_id !== undefined
						? selectedCustomer.agent_id
						: undefined;

				// Fallback for environments where customer LOV does not yet include agent_id.
				if ((customerAgentId === undefined || customerAgentId === null) && param !== undefined) {
					const customerDet = await fetchCustomerDetailsAPI(param);
					customerAgentId =
						customerDet && customerDet.length > 0 ? customerDet[0].agent_id : undefined;
				}
				
				let billing_address,
					vat_input_id,
					tax_id_no = '';

				if (billAddDet.length > 0) {
					setBillAddressList(billAddDet);

					billing_address =
						billAddDet[0].billing_address === undefined ? null : billAddDet[0].billing_address;
					vat_input_id =
						billAddDet[0].vat_input_id === undefined ? null : billAddDet[0].vat_input_id;
					tax_id_no = billAddDet[0].tax_id_no === undefined ? null : billAddDet[0].tax_id_no;
				} else {
					// Set default vat_input_id if no billing details
					vat_input_id = 1; // Default VAT input ID
				}

				form.setFieldsValue({
					billing_address: billing_address === null ? '' : billing_address,
					vat_input_id: vat_input_id === null ? 1 : vat_input_id, // Default to 1 if null
					tax_id_no: tax_id_no === null ? '' : tax_id_no,
					agent: customerAgentId === undefined || customerAgentId === null ? '' : customerAgentId,
				});
			} catch (error) {
				console.log('error', error);
			}
		}
	};

	const onChangePaymentMethod = e => {
		const payMethod = paymentList.filter(items => items.payment_method_id === e);
		const is_bank = payMethod[0].is_bank === false ? true : false;
		const is_cheque = payMethod[0].is_cheque === false ? true : false;

		form.setFieldsValue({ bank_id: '' });
		form.setFieldsValue({ check_no: '' });

		setDisableBank(is_bank);
		setDisableCheck(is_cheque);
	};

	//catches all paymentsdetail (the data table) changes.
	function handlePaymentsDetail(data) {
		const vatableSales = sumBy(data, value => {
			if (value.vatable_sales) {
				return parseFloat(value.vatable_sales.replace(/,/g, ''));
			} else {
				return totalVatSales;
			}
		});

		const payDetVatAmount = sumBy(data, value => {
			if (value.vat_amount) {
				return parseFloat(value.vat_amount.replace(/,/g, ''));
			} else {
				return totalVatSales;
			}
		});

		// form.setFieldsValue({ vatableSales: numberFormat(vatableSales) });
		// form.setFieldsValue({ total_vat_amount: numberFormat(payDetVatAmount) });

		const formValues = form.getFieldsValue();
		
		// Use selectedCustomerID for customer_id in payload instead of form value
		const updatedFormValues = {
			...formValues,
			customer_id: selectedCustomerID || formValues.customer_id
		};

		setPaymentDetail(data);
	}

	//fetches and prepares to be deleted lines from payments_dataTable
	function handleForDelete(data) {
		setLinesForDelete(data);
	}

	//invoice total amount
	function handleTotVal(payload) {
		const getTotPayment = payload;
		const numericTotal = parseFloat(getTotPayment) || 0;
		setpaymentTotAmt(numericTotal);

		const checkVatInputValue = form.getFieldsValue().vat_input_id; //vatInput
		checkVatInput(checkVatInputValue, numericTotal);
	}

	const handleTotDue= (payload) => {
		// console.log('payload =>', payload);
		form.setFieldsValue({ total_amount_due: numberFormat(payload, 2)});
	}

	//invoice total vat sales
	function handleTotVatSales(payload) {
		const getTotVatSales = payload;
		setPaymentTotVatSales(
			!isEditting ? parseFloat(getTotVatSales) : invoiceDetailsProps.vatable_sales,
		);
	}

	//invoice total Vat Amount
	function handleTotVatAmount(payload) {
		const getTotVat = payload;
		setPaymentTotVatAmt(!isEditting ? parseFloat(getTotVat) : invoiceDetailsProps.total_vat_amount);
	}

	//invoice total ewt
	function handleTotEwt(payload) {
		const getTotEwt = payload;
		// form.setFieldsValue({ total_ewt_amount: numberFormat(getTotEwt, 2) });
		// form.setFieldsValue({ total_payment_amount: numberFormat((paymentTotAmt) - ewtValue) })
		setEwtValue(getTotEwt);
	}

	//handle vat input
	function handleVatInputOnChange(value) {
		checkVatInput(value, paymentTotAmt);
	}

	//vat input switch
	const checkVatInput = (value, currentTotal) => {
		const totalToUse = currentTotal !== undefined ? currentTotal : paymentTotAmt;
		switch (value) {
			case 1: //VAT INCLUSIVE
				return form.setFieldsValue({
					total_payment_amount: numberFormat(totalToUse, 2),
				});
			case 2: //VAT EXCLUSIVE
				return form.setFieldsValue({
					total_payment_amount: numberFormat(totalToUse, 2),
				});

			default:
				// 0 rated
				return form.setFieldsValue({
					total_payment_amount: numberFormat(totalToUse, 2),
				});
		}
	};

	const paymentOption = paymentList.map((item, index) => {
		return (
			<Option key={index} value={item.payment_method_id}>
				{item.payment_method_name}
			</Option>
		);
	});

	const bankListOption = bankList.map((item, index) => {
		return (
			<Option key={index} value={item.bank_id}>
				{item.bank_name}
			</Option>
		);
	});

	const vatOption = vatList.map((item, index) => {
		return (
			<Option key={index} value={item.vat_input_id}>
				{item.vat_input_name}
			</Option>
		);
	});

	// Create options for AutoComplete
	const customerNameOptions = customerNameList.map(data => {
		return {
			value: data.customer_id,
			label: data.customer,
			key: data.customer
		};
	});
	
	// Debug customer options
	console.log('Total customer options created:', customerNameOptions.length);

	// Filter customers based on search input
	const handleCustomerSearch = (searchText) => {
		if (!searchText) {
			setFilteredCustomerOptions(customerNameOptions);
			return;
		}
		
		const filtered = customerNameOptions.filter(option =>
			option.label.toLowerCase().includes(searchText.toLowerCase())
		);
		setFilteredCustomerOptions(filtered);
	};

	// Initialize filtered options when customerNameList changes
	useEffect(() => {
		const options = customerNameList.map(data => ({
			value: data.customer_id,
			label: data.customer,
			key: data.customer
		}));
		setFilteredCustomerOptions(options);
	}, [customerNameList]);

	// Separate useEffect to handle customer pre-selection after customerNameList is loaded
	useEffect(() => {
		if (props.isEditting && invoiceDetailsProps.customer_id && customerNameList.length > 0) {


			// Find customer name from customerNameList
			const foundCustomer = customerNameList.find(customer => customer.customer_id === invoiceDetailsProps.customer_id);


			if (foundCustomer) {
				const customerName = foundCustomer.customer;

				setSelectedCustomerID(invoiceDetailsProps.customer_id);
				setSelectedCustomerName(customerName);

				// Set form field to display customer name
				form.setFieldsValue({
					customer_id: customerName
				});
			}
		}
	}, [customerNameList, invoiceDetailsProps.customer_id, props.isEditting]);

	const billingOption = billAddressList.map((item, index) => {
		return (
			<Option key={index} value={item.billing_address} style={{ textTransform: 'uppercase' }}>
				{item.billing_address}
			</Option>
		);
	});

	//get invoice types list
	const invTypesOptions = invTypesList.map((item, index) => {
		return (
			<Option key={item.invoice_type_id} value={item.invoice_type_id}>
				{item.invoice_type_name}
			</Option>
		);
	});

	//get agents list
	const agentOptions = agentsList.map((item, index) => {
		return (
			<Option key={item.agent_id} value={item.agent_id}>
				{item.agent}
			</Option>
		);
	});

	const setSubmitActionValue = action => {
		submitActionRef.current = action;
		setSubmitAction(action);
	};

	const onClickSave = () => {
		setSubmitActionValue('SAVE');
	};

	const onClickPost = () => {
		setSubmitActionValue('POST');
	};

	const onClickCancelled = () => {
		setSubmitActionValue('CANCEL');
	};

	// handle get updated data
	async function handPushResult() {
		const { or_no } = form.getFieldsValue();

		try {
			// search by invoice number
			const result = await fetchHeaderDetails(or_no);
			return result && result[0] ? result[0] : null;
		} catch (error) {
			return error;
		}
	}

	const onClickRefresh = async () => {
		if (props.isEditting) {
			const handlePush = await handPushResult();
			navigate.push({
				pathname: '/payment/update_payment',
				state: handlePush,
			});
			window.location.reload(false);
		} else {
			window.location.reload(false);
		}
	};

	// handle onchange input of tin
	const tinValue = e => {
		const formattedTIN = formatTIN(e.target.value);
		// form.setFieldsValue({ tax_id_no: formattedTIN });
		form.setFieldsValue({ tax_id_no: e.target.value});
	};

	// on blur check existing OR
	const handleExistingOr = async payload => {
		const getOrNo = await fetchExistingOr(payload.target.value);

		if (getOrNo.length > 0) {
			const M0013 = messagesList.filter(items => items.message_code === 'M0013');
			Message.error({ message: M0013[0].message_display });
		}
	};

	// Number-to-words conversion used in print/save payload
	// Required format:
	// - no cents: "THIRTY ONE PESOS ONLY"
	// - with cents: "THIRTY ONE PESOS AND 86 CENTS ONLY"
	function numberToWords(amount) {
		const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
		const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
		const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
		const thousands = ['', 'thousand', 'million', 'billion'];

		const normalizedAmount = Number.parseFloat(
			(amount === undefined || amount === null ? '0' : amount.toString()).replace(/,/g, '').trim(),
		);

		if (Number.isNaN(normalizedAmount)) {
			return '';
		}

		const absoluteAmount = Math.abs(normalizedAmount);
		const [pesoPart, centPart] = absoluteAmount.toFixed(2).split('.');
		const pesos = Number.parseInt(pesoPart, 10);
		const pesoWords = convertToWords(pesos);

		const prefix = normalizedAmount < 0 ? 'negative ' : '';
		if (centPart !== '00') {
			const centValue = Number.parseInt(centPart, 10);
			const centWords = convertToWords(centValue);
			const centLabel = centValue === 1 ? 'cent' : 'cents';
			return `${prefix}${pesoWords} pesos and ${centWords} ${centLabel} only`;
		}

		return `${prefix}${pesoWords} pesos only`;

		function convertToWords(num) {
			if (num === 0) return 'zero';

			let words = '';
			let thousandIndex = 0;

			while (num > 0) {
				const chunk = num % 1000;
				if (chunk !== 0) {
					const chunkWords = convertChunk(chunk);
					words = chunkWords + (thousands[thousandIndex] ? ' ' + thousands[thousandIndex] : '') + (words ? ' ' + words : '');
				}
				num = Math.floor(num / 1000);
				thousandIndex++;
			}

			return words.trim();
		}

		function convertChunk(num) {
			let result = '';
			const hundreds = Math.floor(num / 100);
			const remainder = num % 100;

			if (hundreds > 0) {
				result += ones[hundreds] + ' hundred';
			}

			if (remainder >= 20) {
				const tensDigit = Math.floor(remainder / 10);
				const onesDigit = remainder % 10;
				result += (result ? ' ' : '') + tens[tensDigit];
				if (onesDigit > 0) {
					result += ' ' + ones[onesDigit];
				}
			} else if (remainder >= 10) {
				result += (result ? ' ' : '') + teens[remainder - 10];
			} else if (remainder > 0) {
				result += (result ? ' ' : '') + ones[remainder];
			}

			return result;
		}
	}

	async function handlePrint() {
		setPrintLoading(true);
		try {
			const m0015 = messagesList.filter(items => items.message_code === 'M0015');
			const getStatus = form.getFieldsValue().status;

			if (getStatus === 'CANCELLED') {
				Message.error({ message: m0015[0].message_display });
			} else {
			// Console log current form values for comparison
		const currentFormValues = form.getFieldsValue();
		
		// Get names from lists based on IDs
		const selectedPaymentMethod = paymentList.find(pm => pm.payment_method_id === currentFormValues.payment_method_id);
		const selectedVatInput = vatList.find(vat => vat.vat_input_id === currentFormValues.vat_input_id);
		const resolvedBankId = currentFormValues.bank_id || invoiceDetailsProps.bank_id;
		const selectedBank = bankList.find(
			bank => String(bank.bank_id) === String(resolvedBankId),
		);
		const resolvedBankName =
			invoiceDetailsProps.bank_name && invoiceDetailsProps.bank_name.toString().trim() !== ''
				? invoiceDetailsProps.bank_name
				: (selectedBank ? selectedBank.bank_name : '');
		
		console.log('🔥 Print - selectedPaymentMethod =>', selectedPaymentMethod);
		console.log('🔥 Print - selectedVatInput =>', selectedVatInput);
		
		// Format payment date to MMDDYYYY
		const formattedPaymentDate = moment(currentFormValues.payment_date || invoiceDetailsProps.payment_date).format('MMDDYYYY');
		console.log('🔥 Print - Original payment_date =>', currentFormValues.payment_date || invoiceDetailsProps.payment_date);
		console.log('🔥 Print - Formatted payment_date (MMDDYYYY) =>', formattedPaymentDate);

		// Get total amount due and convert to words
		const totalAmountDue = currentFormValues.total_amount_due || '0';
		const totalAmountDueWords = numberToWords(totalAmountDue);

		const totalInvoiceLines = paymentDetail.length;
		const baseReportDetails = paymentDetail.map(value => {
				return {
					payment_id: invoiceDetailsProps.payment_id,
					or_no: currentFormValues.or_no || invoiceDetailsProps.or_no,
					payment_date: formattedPaymentDate,
					payment_method_id: currentFormValues.payment_method_id || invoiceDetailsProps.payment_method_id,
					payment_method_name: selectedPaymentMethod ? selectedPaymentMethod.payment_method_name : invoiceDetailsProps.payment_method_name,
					bank_id: (!resolvedBankId || resolvedBankId === '') ? ' ' : resolvedBankId,
					bank_name: resolvedBankName,
					check_no: (!invoiceDetailsProps.check_no || invoiceDetailsProps.check_no === '') ? ' ' : invoiceDetailsProps.check_no,
					// remittance_advice_no:
					// 	invoiceDetailsProps.remittance_advice_no === ''
					// 		? ' '
					// 		: invoiceDetailsProps.remittance_advice_no, //invoiceDetailsProps.remittance_advice_no,
					customer_id: invoiceDetailsProps.customer_id,
					customer: invoiceDetailsProps.customer,
					vat_input_id: invoiceDetailsProps.vat_input_id,
					vat_input_name: selectedVatInput ? selectedVatInput.vat_input_name : invoiceDetailsProps.vat_input_name,
					tax_id_no: invoiceDetailsProps.tax_id_no,
					billing_address: invoiceDetailsProps.billing_address,
					collected_by: invoiceDetailsProps.collected_by,
					remarks: invoiceDetailsProps.remarks,
					encoded_by: invoiceDetailsProps.encoded_by,
					total_vat_amount: invoiceDetailsProps.total_vat_amount,
					total_payment_amount: totalAmountDue
						.toString()
						.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','),
					// total_payment_amount: invoiceDetailsProps.total_payment_amount
					// 	.toString()
					// 	.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','),
					total_ewt_amount: invoiceDetailsProps.total_ewt_amount,
					status_id: invoiceDetailsProps.status_id,
					created_by: invoiceDetailsProps.created_by,
					created_date: invoiceDetailsProps.created_date,
					last_updated_by: invoiceDetailsProps.last_updated_by,
					last_updated_date: invoiceDetailsProps.last_updated_date,
					status_name: invoiceDetailsProps.status_name,
					encoded_by_name: invoiceDetailsProps.encoded_by_name,
					//amount_in_word: converter.toWords(invoiceDetailsProps.total_payment_amount) +  ' only',
					// amount_in_word: invoiceDetailsProps.amount_in_word ? invoiceDetailsProps.amount_in_word.toUpperCase() : '', acd old request fixed on 09222025
					amount_in_word: !totalAmountDueWords || totalAmountDueWords === '' ? '' : totalAmountDueWords.toUpperCase(),
					vatable_sales: invoiceDetailsProps.vatable_sales
						? invoiceDetailsProps.vatable_sales.toString()
							.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
						: '0',
					...value,
					total_lines: totalInvoiceLines,
				};
			});
		const report_details = groupInvoices(baseReportDetails);
		const sstest = groupInvoices(baseReportDetails);

		console.log('PRINT sstest:', sstest);

		console.log('PRINT detail count:', report_details);

			const payload = {
				xml_name: 'PRT_PAYMENTS',
				report_name: toUpper(loggedinUser.userName),
				report_details: report_details,
			};
		console.log('PRINT payload details count:', payload.report_details.length);
			
			const handlePrint = await generatePaymentsReport(payload);
			const pdf_file = handlePrint.records[0].pdf;

			let pdfWindow = window.open('');
			pdfWindow.document.write(
				"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(pdf_file) +
					"'></iframe>",
			);
		}
	} catch (error) {
		console.error('Print error:', error);
		Message.error({ message: 'Error generating report' });
	} finally {
		setPrintLoading(false);
	}
}
	function groupInvoices(invoices) {
		 const parseInvoice = (inv) => {
			const match = inv.match(/^(\d+)([A-Za-z]*)$/);
			return match ? { num: parseInt(match[1], 10), suffix: match[2], raw: inv } : null;
		};

		// Sort by invoice_no
		const sorted = [...invoices].sort((a, b) => {
			const pa = parseInvoice(a.invoice_no);
			const pb = parseInvoice(b.invoice_no);
			if (pa.suffix !== pb.suffix) return pa.suffix.localeCompare(pb.suffix);
			return pa.num - pb.num;
		});

		const groups = [];
		let group = [];

		for (let i = 0; i < sorted.length; i++) {
			const curr = sorted[i];
			const currParsed = parseInvoice(curr.invoice_no);

			if (group.length === 0) {
			group.push(curr);
			} else {
			const prev = group[group.length - 1];
			const prevParsed = parseInvoice(prev.invoice_no);

			if (
				currParsed.suffix === prevParsed.suffix &&
				currParsed.num === prevParsed.num + 1
			) {
				group.push(curr);
			} else {
				groups.push(group);
				group = [curr];
			}
			}
		}
		if (group.length > 0) groups.push(group);

		// Now, for each group, create a single object with summed fields and invoice_no as a range
		return groups.map(g => {
			const first = g[0];
			const last = g[g.length - 1];
			// Helper to sum string numbers
			const sumField = (field) =>
			g.reduce((sum, item) => sum + parseFloat((item[field] || "0").toString().replace(/,/g, "")), 0);

			return {
			...first,
			invoice_no: g.length > 1 ? `${first.invoice_no}-${last.invoice_no}` : first.invoice_no,
			invoice_amount: sumField("invoice_amount").toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
			total_amount_due: sumField("total_amount_due").toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
			amount: sumField("amount").toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
			};
		});
	}

	const handleBack = () => {
		const m0008 = messagesList.filter(items => items.message_code === 'M0008');

		const checkBackVal = form.getFieldsValue(null, meta => meta.touched);
		const backArr = Object.values(checkBackVal);

		if (!props.isEditting) {
			//ADD LOGIC
			if (backArr.length > 0 || paymentDetail.length > 0) {
				const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
				const m0008Message =
					m0008[0].message_display === undefined
						? 'Changes will be cancelled'
						: m0008[0].message_display;
				Modal.confirm({
					title: m0008Title,
					icon: <ExclamationCircleOutlined />,
					content: m0008Message,
					okText: 'YES',
					cancelText: 'NO',
					onOk: () => {
						navigate.push('/payment/search');
					},
				});
			} else {
				navigate.push('/payment/search');
			}
		} else {
			//UPDATE LOGIC
			if (status === 'POSTED') {
				if (backArr.length > 5 /*|| paymentDetail.length > 0*/) {
					const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
					const m0008Message =
						m0008[0].message_display === undefined
							? 'Changes will be cancelled'
							: m0008[0].message_display;
					Modal.confirm({
						title: m0008Title,
						icon: <ExclamationCircleOutlined />,
						content: m0008Message,
						okText: 'YES',
						cancelText: 'NO',
						onOk: () => {
							navigate.push('/payment/search');
						},
					});
				} else {
					navigate.push('/payment/search');
				}
			} else if (status === 'NEW') {
				if (backArr.length > 1 /*|| paymentDetail.length > 0*/) {
					const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
					const m0008Message =
						m0008[0].message_display === undefined
							? 'Changes will be cancelled'
							: m0008[0].message_display;
					Modal.confirm({
						title: m0008Title,
						icon: <ExclamationCircleOutlined />,
						content: m0008Message,
						okText: 'YES',
						cancelText: 'NO',
						onOk: () => {
							navigate.push('/payment/search');
						},
					});
				} else {
					navigate.push('/payment/search');
				}
			} else {
				navigate.push('/payment/search');
			}
		}
	};

	async function handleSubmit(formValues) {
		const activeSubmitAction = submitActionRef.current || submitAction;
		if (!activeSubmitAction) {
			return;
		}

		const m0003 = messagesList.filter(items => items.message_code === 'M0003');
		const M0014 = messagesList.filter(items => items.message_code === 'M0014');
		const m0014Message =
			M0014.length > 0 && M0014[0].message_display
				? M0014[0].message_display
				: 'Please add payment details before posting.';
		const paymentLines = Array.isArray(paymentDetail) ? paymentDetail : [];
		const validPaymentLines = paymentLines.filter(isValidPaymentLine);
		const hasIncompletePaymentLines = paymentLines.some(line => !isValidPaymentLine(line));
		// console.log('formValues =>', formValues);
		console.log('paymentDetail =>', paymentDetail);


		// this is done to adjust the code from the commented section of form items (vatableSales and total_vat_amount) in the template.
		
		// Use clean customer_id from state instead of form field
		console.log('Original customer_id from form:', formValues.customer_id);
		console.log('Clean customer_id from state:', selectedCustomerID);
		console.log('🔥 handleSubmit vat_input_id from form =>', formValues.vat_input_id);
		
		const amountInWords = numberToWords(form.getFieldValue('total_amount_due') || formValues.total_amount_due || '0');

		const reformedFormValues = {
			...formValues,
			// Use clean customer_id from dedicated state
			customer_id: selectedCustomerID || formValues.customer_id,
			// Include customer name for saving
			customer: selectedCustomerName || formValues.customer || '',
			// Include amount in words for saving
			amount_in_word: amountInWords ? amountInWords.toUpperCase() : '',
			// Explicitly set totals from numeric states to ensure they are correct
			total_payment_amount: form.getFieldValue('total_amount_due') || '0.00', // DB Payment Total <- Form Payment Total
			total_amount_due: numberFormat(paymentTotAmt, 2), // DB Invoice Total <- State Invoice Total
			vatableSales : numberFormat(paymentTotVatSales, 2),
			total_vat_amount : numberFormat(paymentTotVatAmt, 2),
			total_ewt_amount : numberFormat(ewtValue, 2),
		};

		console.log('reformedFormValues =>', reformedFormValues);
		console.log('customer_id after processing =>', reformedFormValues.customer_id);
		console.log('🔥 handleSubmit final vat_input_id =>', reformedFormValues.vat_input_id);

		if (activeSubmitAction === 'POST') {
			if (validPaymentLines.length === 0) {
				Message.error({ message: m0014Message });
				submitActionRef.current = null;
				setSubmitAction(null);
				return;
			}

			if (hasIncompletePaymentLines) {
				Message.error({ message: 'Please complete or delete empty payment lines before posting.' });
				submitActionRef.current = null;
				setSubmitAction(null);
				return;
			}

			//if editing proceed to confirm
			if (props.isEditting) {
				if (validPaymentLines.length > 0) {
					Modal.confirm({
						title: m0003[0].message_title,
						icon: <ExclamationCircleOutlined />,
						content: m0003[0].message_display,
						okText: 'YES',
						cancelText: 'NO',
						onOk: () => {
							onOkSubmit(reformedFormValues, activeSubmitAction);
						},
						onCancel: () => {
							submitActionRef.current = null;
							setSubmitAction(null);
						},
					});
				} else {
					Message.error({ message: m0014Message });
					submitActionRef.current = null;
					setSubmitAction(null);
				}
			} else if (!props.isEditting) {
				//if adding post
				//if create validate if OR NO is existing
				const getOrNo = await fetchExistingOr(reformedFormValues.or_no);

				if (getOrNo.length > 0) {
					const M0013 = messagesList.filter(items => items.message_code === 'M0013');
					Message.error({ message: M0013[0].message_display });
				} else {
					if (validPaymentLines.length > 0) {
						Modal.confirm({
							title: m0003[0].message_title,
							icon: <ExclamationCircleOutlined />,
							content: m0003[0].message_display,
							okText: 'YES',
							cancelText: 'NO',
							onOk: () => {
								onOkSubmit(reformedFormValues, activeSubmitAction);
							},
							onCancel: () => {
								// setStatus(invoiceDetailsProps.status);
							},
						});
					} else {
						Message.error({ message: m0014Message });
						submitActionRef.current = null;
						setSubmitAction(null);
					}
				}
			} else {
				//if create validate if OR NO is existing
				const getOrNo = await fetchExistingOr(reformedFormValues.or_no);

				if (getOrNo.length > 0) {
					const M0013 = messagesList.filter(items => items.message_code === 'M0013');
					Message.error({ message: M0013[0].message_display });
				} else {
					Modal.confirm({
						title: m0003[0].message_title,
						icon: <ExclamationCircleOutlined />,
						content: m0003[0].message_display,
						okText: 'YES',
						cancelText: 'NO',
						onOk: () => {
							onOkSubmit(reformedFormValues, activeSubmitAction);
						},
					});
				}
			}
		} else if (activeSubmitAction === 'SAVE') {
			if (props.isEditting) {
				Modal.confirm({
					title: m0003[0].message_title,
					icon: <ExclamationCircleOutlined />,
					content: m0003[0].message_display,
					okText: 'YES',
					cancelText: 'NO',
					onOk: () => {
						onOkSubmit(reformedFormValues, activeSubmitAction);
					},
					onCancel: () => {
						submitActionRef.current = null;
						setSubmitAction(null);
					},
				});
			} else {
				const getOrNo = await fetchExistingOr(reformedFormValues.or_no);

				if (getOrNo.length > 0) {
					const M0013 = messagesList.filter(items => items.message_code === 'M0013');
					Message.error({ message: M0013[0].message_display });
				} else {
					Modal.confirm({
						title: m0003[0].message_title,
						icon: <ExclamationCircleOutlined />,
						content: m0003[0].message_display,
						okText: 'YES',
						cancelText: 'NO',
						onOk: () => {
							onOkSubmit(reformedFormValues, activeSubmitAction);
						},
					});
				}
			}
		} else if (activeSubmitAction === 'CANCEL') {
			const M0009 = messagesList.filter(items => items.message_code === 'M0009');
			Modal.confirm({
				title: M0009[0].message_title,
				icon: <ExclamationCircleOutlined />,
				content: M0009[0].message_display,
				okText: 'YES',
				cancelText: 'NO',
				onOk: () => {
					onOkSubmit(reformedFormValues, activeSubmitAction);
				},
				onCancel: () => {
					submitActionRef.current = null;
					setSubmitAction(null);
				},
			});
		}
	}

	async function onOkSubmit(formValues, activeSubmitAction) {
		const payload = {
			...formValues,
			payment_date: moment(formValues.payment_date).format('YYYY/MM/DD'),
			encoded_by: loggedinUser.userID,
			status_name: activeSubmitAction,
			created_by: loggedinUser.userID,
			payment_id: props.isEditting ? invoiceDetailsProps.payment_id : undefined,
		};
		try {
			const m0014 = messagesList.filter(items => items.message_code === 'M0014');
			const m0014Fallback = {
				message_code: 'M0014',
				message_display: 'Please add payment details before posting.',
			};
			const paymentLines = Array.isArray(paymentDetail) ? paymentDetail : [];
			const validPaymentLines = paymentLines.filter(isValidPaymentLine);
			const hasIncompletePaymentLines = paymentLines.some(line => !isValidPaymentLine(line));
			const paymentLinesForSubmission =
				activeSubmitAction === 'POST' ? validPaymentLines : paymentLines;

			if (
				activeSubmitAction === 'POST' &&
				(validPaymentLines.length === 0 || hasIncompletePaymentLines)
			) {
				throw (m0014[0] || m0014Fallback); // force validation error
			}

			if (props.isEditting) {
				//EDIT

				const dataForPaymentDetail = paymentLinesForSubmission.map(value => {
					return {
						...value,
						ewt_percent: value.ewt.replace(/[%\s]/g, ''),
						ewt_amount: value.ewt_amount,
						is_full_payment: value.full_payment,
						payment_description: value.invoice_no,
						updated_by: loggedinUser.userID,
						updated_date: formValues.payment_date,
					};
				});

				const updateResult = await updatePaymentHeader(payload, dataForPaymentDetail);

				if (linesForDelete.length > 0) {
					await deletePaymentLines(linesForDelete);
				}

				if (updateResult.status === 200) {
					setDataForRefresh(updateResult.data);

					// Ensure customer field remains selected after save
					if (selectedCustomerName) {
						form.setFieldsValue({ customer_id: selectedCustomerName });
					}

					const m0006 = messagesList.filter(items => items.message_code === 'M0006');
					const m0005 = messagesList.filter(items => items.message_code === 'M0005');
					const m0010 = messagesList.filter(items => items.message_code === 'M0010');

					if (activeSubmitAction === 'POST') {
						Message.success({ message: m0005[0].message_display });
						const handlePush = await handPushResult();
						navigate.push({
							pathname: '/payment/update_payment',
							state: handlePush,
						});
						window.location.reload();
					} else if (activeSubmitAction === 'SAVE') {
						Message.success({ message: m0006[0].message_display });
						const handlePush = await handPushResult();
						navigate.push({
							pathname: '/payment/update_payment',
							state: handlePush,
						});
						window.location.reload();
					} else if (activeSubmitAction === 'CANCEL') {
						Message.success({ message: m0010[0].message_display });
						const handlePush = await handPushResult();
						navigate.push({
							pathname: '/payment/update_payment',
							state: handlePush,
						});
						window.location.reload();
					}
				}
			} else {
				const dataForPaymentDetail = paymentLinesForSubmission.map(value => {
					return {
						...value,
						ewt_id: value.ewt.replace(/[%\s]/g, ''),
						is_full_payment: value.full_payment,
						payment_description: value.invoice_no,
						created_by: loggedinUser.userID,
						created_date: formValues.payment_date,
					};
				});
				const result = await addPaymentHeader(payload, dataForPaymentDetail);
				setDataForRefresh(result.data);

				if (result.status === 200) {
					// setDataForRefresh(result);

					// Ensure customer field remains selected after save
					if (selectedCustomerName) {
						form.setFieldsValue({ customer_id: selectedCustomerName });
					}

					const m0004 = messagesList.filter(items => items.message_code === 'M0004'); //Transaction successfully created.
					const m0005 = messagesList.filter(items => items.message_code === 'M0005'); //Transaction successfully posted.

					if (activeSubmitAction === 'POST') {
						Message.success({ message: m0005[0].message_display });
						const handlePush = await handPushResult();
						navigate.push({
							pathname: '/payment/update_payment',
							state: handlePush,
						});
						window.location.reload();
					} else if (activeSubmitAction === 'SAVE') {
						Message.success({ message: m0004[0].message_display });
						const handlePush = await handPushResult();
						navigate.push({
							pathname: '/payment/update_payment',
							state: handlePush,
						});
						window.location.reload();
					} else {
						Message.success({ message: 'Payments successfully Added.' });
					}
					// navigate.push('/payment/search');
				}
			}
		} catch (error) {
			submitActionRef.current = null;
			setSubmitAction(null);
			//Exception during form submission.
			const { message_code, message_display } = error;

			if (message_code === 'M0014') {
				Message.error({ message: message_display });
			} else {
				const m0007 = messagesList.filter(items => items.message_code === 'M0007');
				Message.error({ message: m0007[0].message_display }); // for any unhandled issues.
				// for anything else, there's mastercard.
			}
		}
	}

	const toggleClearing = () => {
		switch (clearPaymentLines) {
			case true:
				setClearPaymentLines(false);
				break;

			case false:
				setClearPaymentLines(true);
				break;
			default:
				break;
		}
	};

	const formStatus = (() => {
		return form.getFieldsValue().status;
	})();

	const requiredFieldRule = [{ required: true, message: 'Required Field' }];

	const bankRules = (() => {
		if (!disableBank) {
			return requiredFieldRule;
		} else {
			return [];
		}
	})();

	const checkRules = (() => {
		if (!disableCheck) {
			return requiredFieldRule;
		} else {
			return [];
		}
	})();

	const isHeaderEditable = !((props.isEditting && status !== 'NEW') || updatePayment === 'FALSE');
	const houseOwnRules = isHeaderEditable ? requiredFieldRule : [];

	return isloading ? (
		<div className="spin-loading">
			<Spin tip="Loading..." size="large"></Spin>
		</div>
	) : (
		<div>
			<Card>
				<PageTitle pageTitle="PAYMENT" />
				<Form
					layout="vertical"
					form={form}
					className="payment-dataentry-form"
					onFinish={handleSubmit}
				>
					<Row gutter={[8, 1]} justify="space-around" align="top">
						<Col span={5}>
							<Form.Item
								style={formItemStyle}
								name="or_no"
								label="O.R NO."
								initialValue={props.isEditting ? invoiceDetailsProps.or_no : ''}
								rules={requiredFieldRule}
							>
								<AlphaNumInput
									onBlur={handleExistingOr}
									placeholder="O.R NO."
									maxLength={50}
									disabled={props.isEditting || updatePayment === 'FALSE'}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="payment_date"
								label="PAYMENT DATE"
								rules={requiredFieldRule}
								initialValue={
									props.isEditting ? moment(invoiceDetailsProps.payment_date) : moment()
								}
							>
								<DatePicker
									format="MM/DD/YYYY"
									style={{ width: '100%' }}
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								/>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item
								style={formItemStyle}
								name="payment_method_id"
								label="PAYMENT METHOD"
								initialValue={props.isEditting ? invoiceDetailsProps.payment_method_id : ''}
								rules={requiredFieldRule}
							>
								<Select
									placeholder="PAYMENT METHOD"
									showSearch
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
									onChange={onChangePaymentMethod}
									allowClear={true}
									filterOption={(input, option) =>
										option.children.toLowerCase().includes(input.toLowerCase())
									}
								>
									{paymentOption}
								</Select>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item
								style={formItemStyle}
								name="bank_id"
								label="BANK"
								initialValue={props.isEditting ? invoiceDetailsProps.bank_id : ''}
								rules={bankRules}
							>
								<Select
									// onChange={onChangeCustomer}
									placeholder="BANK"
									allowClear={true}
									showSearch
									disabled={disableBank || status === 'POSTED' || updatePayment === 'FALSE'}
									filterOption={(input, option) =>
										option.children.toLowerCase().includes(input.toLowerCase())
									}
								>
									{bankListOption}
								</Select>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item
								style={formItemStyle}
								name="check_no"
								label="CHECK NO"
								initialValue={props.isEditting ? invoiceDetailsProps.check_no : ''}
								rules={checkRules}
							>
								<AlphaNumInput
									placeholder="CHECK NO"
									disabled={disableCheck || status === 'POSTED' || updatePayment === 'FALSE'}
									maxLength={50}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} justify="space-around" align="top">
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="customer_id"
								label="CUSTOMER"
								rules={requiredFieldRule}
								initialValue={props.isEditting ? invoiceDetailsProps.customer : ''}
							>
								<AutoComplete
									options={filteredCustomerOptions}
									onSearch={handleCustomerSearch}
									onSelect={(value, option) => {
										console.log('🔥 onSelect TRIGGERED! Value:', value, 'Option:', option);
										
										// Find the customer data by id
										const selectedCustomer = customerNameList.find(customer => customer.customer_id === value);
										console.log('🔥 Found selectedCustomer:', selectedCustomer);
										
										if (selectedCustomer) {
											// Set display value for form field (customer name for intellisense)
											form.setFieldsValue({ customer_id: selectedCustomer.customer });
											console.log('🔥 Form field set to:', selectedCustomer.customer);
											
											// Store clean customer ID and name in separate states
											handleCustomerSelection(selectedCustomer.customer_id, selectedCustomer.customer);
										}
									}}
									onChange={(value) => {
										// Handle direct typing without selection
										if (typeof value === 'string') {
											// User is typing directly
											const matchingCustomer = customerNameList.find(customer => 
												customer.customer.toLowerCase() === value.toLowerCase()
											);
											if (matchingCustomer) {
												onChangeCustomer(matchingCustomer.customer_id);
											}
										}
									}}
									placeholder="Type customer name..."
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
									allowClear={true}
									style={{ width: '100%' }}
									filterOption={false} // We handle filtering manually
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="billing_address"
								label="BILLING ADDRESS"
								initialValue={props.isEditting ? invoiceDetailsProps.billing_address : ''}
								rules={requiredFieldRule}
							>
								<AutoComplete
									placeholder={'BILLING ADDRESS'}
									showSearch
									disabled={
										disable ||
										status === 'POSTED' ||
										status === 'CANCELLED' ||
										updatePayment === 'FALSE'
									}
									mode="tags"
									autoClearSearchValue={true}
									tokenSeparators={[',']}
								>
									{billingOption}
								</AutoComplete>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} justify="space-around">
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="tax_id_no"
								label="TAX ID. NO"
								initialValue={props.isEditting ? invoiceDetailsProps.tax_id_no : ''}
							>
								<AlphaNumInput
									className="inv-input-uppercase"
									placeholder="000-000-000-00000"
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
									onChange={tinValue}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="collected_by"
								label="COLLECTED BY"
								initialValue={props.isEditting ? invoiceDetailsProps.collected_by : ''}
							>
								<AlphaNumInput
									placeholder="COLLECTED BY"
									maxLength={50}
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="encoded_by"
								label="ENCODED BY"
								initialValue={
									props.isEditting ? invoiceDetailsProps.encoded_by_name : loggedinUser.userName
								}
							>
								<Input placeholder="ENCODED BY" disabled={true} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="remarks"
								label="REMARKS"
								initialValue={props.isEditting ? invoiceDetailsProps.remarks : ''}
							>
								<Input
									placeholder="REMARKS"
									maxLength={100}
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]}>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="total_payment_amount"
								label="TOTAL AMOUNT DUE"
								initialValue={props.isEditting ? invoiceDetailsProps.total_amount_due : 0.0}
							>
								<Input style={{ width: '100%' }} disabled={true}></Input>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="total_amount_due"
								label="TOTAL PAYMENT AMOUNT"
								initialValue={props.isEditting ? invoiceDetailsProps.total_payment_amount : 0.0}
							>
								<Input style={{ width: '100%' }} disabled={true}></Input>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="agent"
								label="AGENT"
								initialValue={props.isEditting ? invoiceDetailsProps.agent_id : ''}
								rules={requiredFieldRule}
							>
								<Select
									showSearch
									placeholder="AGENT"
									optionFilterProp="children"
									filterOption={(input, option) =>
										(option.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									// onChange={handleInvStatus}
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								>
									{agentOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col span={4}>
							
						</Col>
						<Col span={4}>
							<Form.Item
								name="house_own"
								label="HOUSE/OWN"
								initialValue={props.isEditting ? toUpper(invoiceDetailsProps.house_own || '') : ''}
								rules={houseOwnRules}
							>
								<Radio.Group
									className="blood-request-radio-btn"
									style={{ paddingLeft: 15 }}
									disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								>
									<Radio value="HOUSE">HOUSE</Radio>
									<Radio value="OWN">OWN</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
					</Row>
					<Col span={4}>
						<Form.Item
							style={formItemStyle}
							name="vat_input_id"
							label="VAT INPUT"
							hidden={true}
							initialValue={props.isEditting ? invoiceDetailsProps.vat_input_id : ''}
						>
							<Select
								placeholder="VAT INPUT"
								disabled={(props.isEditting && status !== 'NEW') || updatePayment === 'FALSE'}
								showSearch
								onChange={handleVatInputOnChange}
								allowClear={true}
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
							>
								{vatOption}
							</Select>
						</Form.Item>
					</Col>
					<PaymentsDataTable
						handleTotVal={handleTotVal}
						handleTotDue={handleTotDue}
						handleTotEwt={handleTotEwt}
						handleTotVatSales={handleTotVatSales}
						handleTotVatAmount={handleTotVatAmount}
						paymentsDetail={handlePaymentsDetail}
						forDelete={handleForDelete}
						invoiceDetailsProps={invoiceDetailsProps}
						isEditting={isEditting}
						status={status}
						customerID={customerID}
						invBalDet={listInvBalances}
						clearPaymentLines={clearPaymentLines}
						headerForm={form}
					/>
					<Row gutter={[8, 1]} justify="space-around">
						<Col className="button-below" span={14}>
							<Button
								style={buttonStyle}
								type="primary"
								icon={<PrinterOutlined />}
								onClick={handlePrint}
								loading={printLoading}
								disabled={status === 'CANCELLED' || userAccess['payments'].print === 'FALSE' || printLoading}
								hidden={status === 'CANCELLED' || !props.isEditting}
							>
								{printLoading ? 'PRINTING...' : 'PRINT'}
							</Button>
							<Button
								style={buttonStyle}
								type="primary"
								icon={<SyncOutlined />}
								onClick={onClickRefresh}
								disabled={status === 'CANCELLED' || updatePayment === 'FALSE'}
							>
								REFRESH
							</Button>
						</Col>
						<Col className="button-below" span={10}>
							<div style={footerStyleRight}>
								<Button
									style={buttonStyle}
									type="primary"
									icon={<RollbackOutlined />}
									onClick={handleBack}
									// onClick={() => navigate.push('/payment/search')}
								>
									BACK
								</Button>
								{/* {(props.isEditting) && (cancelPayment !== undefined) ? ( */}
								{props.isEditting && cancelPayment === 'TRUE' ? (
									<Button
										style={buttonStyle}
										type="primary"
										icon={<DeleteOutlined />}
										htmlType="submit"
										onClick={onClickCancelled}
										hidden={!props.isEditting}
										disabled={status === 'CANCELLED' || updatePayment === 'FALSE'}
									>
										CANCEL PAYMENT
									</Button>
								) : null
								// (
								// 	<Button
								// 		style={buttonStyle}
								// 		type="primary"
								// 		icon={<DeleteOutlined />}
								// 		htmlType="submit"
								// 		onClick={onClickCancelled}
								// 		hidden={!props.isEditting}
								// 	>
								// 		CANCEL PAYMENT
								// 	</Button>
								// )
								}
								{props.isEditting ? (
									<Button
										style={buttonStyle}
										type="primary"
										icon={<SaveOutlined />}
										htmlType="submit"
										onClick={onClickSave}
										disabled={
											status === 'CANCELLED' || status === 'POSTED' || updatePayment === 'FALSE'
										}
									>
										SAVE
									</Button>
								) : (
									<Button
										style={buttonStyle}
										type="primary"
										icon={<SaveOutlined />}
										htmlType="submit"
										onClick={onClickSave}
									>
										SAVE
									</Button>
								)}
								{props.isEditting ? (
									<Button
										style={buttonStyle}
										type="primary"
										htmlType="submit"
										icon={<SnippetsOutlined />}
										onClick={onClickPost}
										disabled={
											status === 'CANCELLED' ||
											status === 'POSTED' ||
											userAccess['payments'].post === 'FALSE'
										}
									>
										POST
									</Button>
								) : (
									<Button
										style={buttonStyle}
										type="primary"
										htmlType="submit"
										icon={<SnippetsOutlined />}
										onClick={onClickPost}
									>
										POST
									</Button>
								)}
							</div>
						</Col>
					</Row>
				</Form>
			</Card>
		</div>
	);
}

